export default __webpack_public_path__ + "static/media/graphics-id-verfication-id-verification-inprogress.a0956276.svg";